import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { XCircle } from "lucide-react";
import { useLang } from "@/context/LanguageContext";

export default function PaymentCancel() {
  const { t } = useLang();
  return (
    <main data-testid="payment-cancel-page" className="max-w-xl mx-auto px-6 py-24">
      <div className="bg-white rounded-3xl border border-zinc-100 p-10 text-center">
        <div className="w-16 h-16 rounded-full bg-zinc-100 flex items-center justify-center mx-auto">
          <XCircle className="w-9 h-9 text-zinc-500" />
        </div>
        <h1 className="mt-6 font-display font-extrabold text-3xl text-zinc-900">{t("payment.cancelled")}</h1>
        <p className="mt-3 text-zinc-600">{t("payment.cancelledSub")}</p>
        <div className="mt-8 flex gap-3 justify-center">
          <Link to="/checkout"><Button className="rounded-full bg-brand hover:bg-brand-hover text-white px-6">{t("payment.returnToCheckout")}</Button></Link>
          <Link to="/shop"><Button variant="outline" className="rounded-full">{t("checkout.continueShopping")}</Button></Link>
        </div>
      </div>
    </main>
  );
}
